<template>
  <div id="CampaignEditDetails" class="Main-Content">
    <ValidationObserver v-slot="{ invalid }" slim>
      <Modal :visible="visible" @close="visible = false"/>
      <Page
        v-if="loading"
        :title="`${$t('Editing')} ...`"
        :primaryAction="{
          label: $t('Save'),
          disabled: true 
        }"
        :secondaryActions="[{
          label: $t('Notes'),
          disabled: true
        }]"
      >
        <LoadingLayout/>
      </Page>
      <Page
        v-if="!loading"
        :title="`${$t('Editing')} '${campaign.name}'`"
        :primaryAction="{
          label: $t('Save'),
          onAction: save,
          disabled: invalid || saving
        }"
        :secondaryActions="[{
          label: $t('Notes'),
          onAction: () => { eventHub.$emit('showCampaignNotes', campaign.id) }
        }]"
      >
        <campaign-edit-header :campaign="campaign"></campaign-edit-header>

        <Layout>
          <LayoutSection>
            <Card :title="$t('Campaign Overview')">
              <CardSection>
                <FormLayout>
                  <validation-provider :name="$t('Campaign Name')" immediate rules="required" v-slot="{ errors }">
                    <TextField
                      :label="$t('Name')"
                      v-model="campaign.name"
                      :error="errors[0]"
                    />
                  </validation-provider>
                  <DatePicker
                    :label="$t('Start Date')"
                    v-model="campaign.stDate"
                  />
                  <TimezonePicker :value="campaign.timezone" :label="$t('Timezone')" readonly/>
                  <Select
                    :label="$t('Currency')"
                    v-model="campaign.currency"
                    :options="currencies"
                  />
                  <Select v-if="campaign.widgetConfiguration && campaign.widgetConfiguration.language"
                    :label="$t('Language')"
                    v-model="campaign.widgetConfiguration.language"
                    :options="languages"
                  />
                </FormLayout> 
              </CardSection>
            </Card>
          </LayoutSection>
        </Layout>
      </Page>
    </ValidationObserver>

  </div>
</template>

<script>
import CampaignEditHeader from '@/components/CampaignEditHeader'

export default {
  name: 'CampaignEditDetails',
  data () {
    return {
      loading: true,
      saving: false,
      currencies: [],
      languages: [],
      campaign: null,
      visible: false
    }
  },
  mounted() {
    NProgress.start()
    Promise.all([this.api.getCampaign(parseInt(this.$route.params.id)), this.api.getCurrenciesList(), this.api.getLanguageList()])   
      .then((data) => {
        const [ campaign, currencies, languages ] = data
        this.campaign = campaign
        this.currencies = currencies
        this.languages = languages && languages.map(l => {
          return {
            value: l.value,
            label: this.$t(`language.${l.value}`)
          }
        })
        this.loading = false
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
  },
  methods: {
    save() {
      // this.$router.push(`/campaigns/${this.campaign.id}/offers/`)
      NProgress.start()
      this.saving = true
      this.api.updateCampaign(this.campaign) 
        .then(() => {
          this.$ui.toast({ title: this.$t('Saved') })
        })
        .catch(this.apiCatch)
        .finally(() => {
          this.saving = false
          NProgress.done()
        })
    },
  },
  components: {
    CampaignEditHeader
  }
}

</script>

<style lang="scss">
</style>